/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarSlot/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarSlot({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarSlot",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarSlot.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZLzRsb': alignSelf,'--mt-2-ZLzRsb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZLzRsb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZLzRsb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZLzRsb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZLzRsb': opacity,'--w-10-ZLzRsb': typeof width === 'number' ? `${width}px` : width,'--h-11-ZLzRsb': typeof height === 'number' ? `${height}px` : height,'--f-12-ZLzRsb': fill,'--a-7-ZLzRsb': isAnimated ? animation : "none",'--sd-8-ZLzRsb': isAnimated ? strokeDashoffset : 0,'--sd-9-ZLzRsb': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarSlot.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.5 0a1 1 0 011 1v1h5V1a1 1 0 112 0v1h1A1.5 1.5 0 0114 3.5v9a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 12.5v-9A1.5 1.5 0 011.5 2h1V1a1 1 0 011-1zm1.872 7c0-.347.281-.628.628-.628h4a.627.627 0 110 1.256H6A.627.627 0 015.372 7zM6 9.373a.627.627 0 100 1.255h1a.627.627 0 100-1.255H6zM2.873 7c0-.347.28-.628.627-.628H4a.627.627 0 110 1.256h-.5A.627.627 0 012.873 7zM3.5 9.373a.627.627 0 100 1.255H4a.627.627 0 100-1.255h-.5z"
 style={{'--f-12-ZLzRsb': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}